import { stripTime } from "./timesheet-allowed-dates.ts";

/** Add or update ranges here when temporary open-entry windows change. */
export const TIMESHEET_OPEN_WINDOWS = [
  {
    from: "2026-06-15",
    to: "2026-07-03",
  },
  {
    from: "2026-07-08",
    to: "2026-07-24",
  },
] as const;

function parseLocalIsoDate(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return stripTime(new Date(year, month - 1, day));
}

export function isWithinTimesheetOpenWindow(date: Date): boolean {
  const selected = stripTime(date).getTime();
  return TIMESHEET_OPEN_WINDOWS.some(({ from, to }) => {
    const fromTime = parseLocalIsoDate(from).getTime();
    const toTime = parseLocalIsoDate(to).getTime();
    return selected >= fromTime && selected <= toTime;
  });
}

/** Temporary reopening for employee 741; remove after 6 November 2026. */
export function isWithinTemporaryEmployeeTimesheetWindow(
  employeeId: number | undefined,
  date: Date,
  now = new Date(),
): boolean {
  if (Number(employeeId) !== 741) return false;
  const selected = stripTime(date).getTime();
  return (
    now.getTime() <= new Date("2026-11-06T23:59:59.999+05:30").getTime() &&
    selected >= parseLocalIsoDate("2026-10-16").getTime() &&
    selected <= parseLocalIsoDate("2026-10-31").getTime()
  );
}
